const Bag = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#000",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="2689"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M860.416 881.223111l-28.401778-527.473778C831.544889 299.776 787.512889 256 733.411556 256H666.737778V129.095111C666.752 77.397333 622.677333 42.666667 565.105778 42.666667h-101.489778c-59.434667 0-95.530667 35.541333-95.544889 86.428444V256h-77.482667a98.702222 98.702222 0 0 0-98.588444 97.749333l-28.401778 527.473778A98.702222 98.702222 0 0 0 262.144 981.333333h499.712a98.716444 98.716444 0 0 0 98.56-100.110222zM424.96 129.095111C424.96 101.674667 453.262222 99.555556 463.601778 99.555556h101.504c26.083556 0 44.743111 9.941333 44.743111 29.539555V256h-184.888889V129.095111zM761.856 924.444444H262.144a41.756444 41.756444 0 0 1-41.699556-41.031111l28.401778-527.303111a27.164444 27.164444 0 0 0 0.042667-1.521778A41.756444 41.756444 0 0 1 290.588444 312.888889h442.823112a41.756444 41.756444 0 0 1 41.713777 41.699555c0 0.512 0.014222 1.009778 0.042667 1.521778l28.401778 527.303111A41.770667 41.770667 0 0 1 761.856 924.444444z"
      fill={color}
      p-id="2690"
    ></path>
    <path
      d="M306.531556 569.443556c-8.248889-0.355556-14.549333 6.058667-14.961778 13.895111l-0.554667 11.505777c-0.412444 7.850667 5.617778 16.711111 13.454222 16.711112h0.768c7.509333 0 13.795556-7.523556 14.193778-15.132445l0.554667-12.231111a14.037333 14.037333 0 0 0-13.454222-14.748444zM303.573333 625.251556a14.122667 14.122667 0 0 0-14.961777 13.454222l-11.264 213.873778a14.222222 14.222222 0 0 0 13.454222 14.961777l0.768 0.014223a14.222222 14.222222 0 0 0 14.193778-13.468445l11.264-213.859555a14.222222 14.222222 0 0 0-13.454223-14.976z"
      fill={color}
      p-id="2691"
    ></path>
  </svg>
);

export default Bag;
